export class FilterCrest{
    ctrl_page: number;
    ctrl_description: string;
    ctrl_group_id: number;
    ctrl_cresttype_id: number;
    ctrl_status: string;
}

export class FilterShirt{
    ctrl_page: number;
    ctrl_description: string;
    ctrl_group_id: number;
    ctrl_cresttype_id: number;
    ctrl_status: string;
}
export class FilterLeague{
    ctrl_page: number;
    ctrl_description: string;
    ctrl_group_id: number;
    ctrl_cresttype_id: number;
    ctrl_status: string;
}
export class FilterSponsor{
    ctrl_page: number;
    ctrl_description: string;
    ctrl_group_id: number;
    ctrl_cresttype_id: number;
    ctrl_status: string;
}